export const AUTH_TOKEN_KEY = 'pnl_evonucleus_token';

export function getStoredToken() {
  try {
    return sessionStorage.getItem(AUTH_TOKEN_KEY);
  } catch {
    return null;
  }
}

export function setStoredToken(token) {
  sessionStorage.setItem(AUTH_TOKEN_KEY, token);
}

export function clearStoredToken() {
  sessionStorage.removeItem(AUTH_TOKEN_KEY);
}
